var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaluty = function SvgWaluty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st13{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M19.8,6H0.9C0.4,6,0,6.4,0,6.9v10.6c0,0.5,0.4,0.9,0.9,0.9h14.8v-1.8H1.8V7.8h17.1v6.1h1.8v-7 C20.7,6.4,20.3,6,19.8,6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M10.5,8.6c-2,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5S14,14,14,12.1S12.4,8.6,10.5,8.6z M10.5,14 c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8S11.4,14,10.5,14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M18,3H2.7C2.2,3,1.8,3.4,1.8,3.9s0.4,0.9,0.9,0.9H18c0.5,0,0.9-0.4,0.9-0.9S18.5,3,18,3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M16.2,0.1H4.4C3.9,0.1,3.5,0.5,3.5,1s0.4,0.9,0.9,0.9h11.8c0.5,0,0.9-0.4,0.9-0.9S16.7,0.1,16.2,0.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M19.4,13c-2.3,0-4.6,0.7-4.6,2.2s2.3,2.2,4.6,2.2s4.6-0.7,4.6-2.2S21.7,13,19.4,13z M19.4,15.8 c-1.3,0-2.2-0.3-2.6-0.5c0.4-0.2,1.3-0.5,2.6-0.5s2.2,0.3,2.6,0.5C21.6,15.5,20.7,15.8,19.4,15.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M22.2,18.4c0-0.1,0-0.2,0-0.2c-0.2,0.2-1.2,0.6-2.9,0.6c-1.7,0-2.7-0.4-2.9-0.6c0,0,0,0.1,0,0.2h-1.8 c0,1.6,2.3,2.2,4.6,2.2S24,20,24,18.4H22.2L22.2,18.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M22.2,15.3v6.3c-0.3,0.2-1.3,0.6-2.8,0.6s-2.6-0.4-2.8-0.6v-6.3h-1.8v6.4c0,1.6,2.3,2.2,4.6,2.2 s4.6-0.7,4.6-2.2v-6.4C24,15.3,22.2,15.3,22.2,15.3z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaluty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waluty.ed37933e.svg";
export { ForwardRef as ReactComponent };